export default {
  data() {
    return {
      zoomLevel: 1,
      minZoomLevel: 1,
      maxZoomLevel: 3,
    };
  },

  methods: {
    zoomImage(event) {
      const image = event.target;

      if (image.tagName !== 'IMG') {
        return;
      }

      const scaleStep = 0.2;
      const zoomIn = event.deltaY < 0;

      if (zoomIn && this.zoomLevel >= this.maxZoomLevel) {
        return;
      }

      if (zoomIn && this.zoomLevel < this.maxZoomLevel) {
        this.zoomLevel += scaleStep;
        if (this.zoomLevel > this.maxZoomLevel) {
          this.zoomLevel = this.maxZoomLevel;
        }
      } else if (!zoomIn && this.zoomLevel > this.minZoomLevel) {
        this.zoomLevel -= scaleStep;
      }

      const rect = image.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;
      const offsetY = event.clientY - rect.top;
      const originX = (offsetX / rect.width) * 100;
      const originY = (offsetY / rect.height) * 100;

      image.style.transformOrigin = `${originX}% ${originY}%`;
      image.style.transform = `scale(${this.zoomLevel})`;
    },
  },
};
